import React from 'react';
import nebulaTheme from '@nebula/theme';
import { Modal } from '@nebula/modal';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from '@nebula/global-styles';
import PropTypes from 'prop-types';
import { trackKeepSubscriptionClick } from '../../helpers/switch/analytics';
import { ModalLabel } from './index.styles';

const ConfirmCancelDialog = ({ isShowing, toggleHide, onConfirm, onNotNow, bodyText, subscriptionFamily }) => (
  <ThemeProvider theme={nebulaTheme}>
    <GlobalStyles />
    <Modal
      zIndex={20}
      header="Are you sure you want to cancel?"
      isShowing={isShowing}
      toggleHide={toggleHide}
      showDefaultCloseBtn={false}
      actions={[
        {
          label: 'Confirm',
          onClick: () => {
            toggleHide();
            onConfirm();
          },
          buttonKind: 'primaryMagenta',
        },
        {
          label: 'Not now',
          onClick: () => {
            toggleHide();
            trackKeepSubscriptionClick(subscriptionFamily, 'modal');
            onNotNow();
          },
          buttonKind: 'secondaryMagenta',
        },
      ]}
    >
      <ModalLabel>{bodyText}</ModalLabel>
    </Modal>
  </ThemeProvider>
);

ConfirmCancelDialog.propTypes = {
  isShowing: PropTypes.bool.isRequired,
  toggleHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  bodyText: PropTypes.string.isRequired,
  subscriptionFamily: PropTypes.string.isRequired,
  onNotNow: PropTypes.func.isRequired,
};

export default ConfirmCancelDialog;
